function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { z } from 'zod';
import { ContentTypeQuery } from './query/ContentTypeQuery';
import { UnresolvableReferenceError } from './UnresolvableReferenceError';
import { denormalizedResponse } from './normalization';
function isNotUndefined(obj) {
    return obj !== undefined;
}
function entryLink() {
    return z.object({
        link_type: z.literal('Entry'),
        primary_key: z.string()
    });
}
function assetLink() {
    return z.object({
        link_type: z.literal('Asset'),
        primary_key: z.string()
    });
}
function getOrAddWithErrorHandling({ denormalized, normalized }, normalizer, link, ctx) {
    try {
        return normalized.getOrAdd(link, ()=>normalizer.parse(denormalized.resolve(link)));
    } catch (err) {
        if (err instanceof UnresolvableReferenceError) {
            ctx.addIssue({
                code: 'custom',
                message: err.message
            });
            return z.NEVER;
        } else if (err instanceof z.ZodError) {
            err.issues.forEach((issue)=>ctx.addIssue(issue));
            return z.NEVER;
        } else {
            throw err;
        }
    }
}
export function normalizedEntry(managers, normalizer) {
    return entryLink().transform((link, ctx)=>getOrAddWithErrorHandling(managers, normalizer, link, ctx));
}
function assetSchema() {
    return z.object({
        file: z.object({
            url: z.string()// If you are responding to an incident due to stripeassets.com domain
            // being unavailable, see the runbook: http://go/th/trh_doc_R0PtduTwPFi0Fn
            .transform((url)=>url.replace('.ctfassets.net', '.stripeassets.com'))
        })
    });
}
export function normalizedAsset(managers) {
    return assetLink().transform((link, ctx)=>getOrAddWithErrorHandling(managers, assetSchema(), link, ctx));
}
export class ContentType {
    where(// NB: This refinement ensure that this object does
    // not contain any keys *not* present the content type
    fields) {
        return new ContentTypeQuery(this, fields);
    }
    generateSchema(managers) {
        const referenceFactories = {
            asset () {
                return normalizedAsset(managers);
            },
            reference (model) {
                return model.generateSchema(managers);
            }
        };
        const schema = this.schemaFactory(referenceFactories);
        return normalizedEntry(managers, schema);
    }
    createResponseSchema(managers) {
        return denormalizedResponse.transform((_param, ctx)=>{
            var { rootIds, entries, assets } = _param, rest = _object_without_properties(_param, [
                "rootIds",
                "entries",
                "assets"
            ]);
            managers.denormalized.add({
                entries,
                assets
            });
            const schema = this.generateSchema(managers);
            return _object_spread({
                items: rootIds.map((id, i)=>schema.parse({
                        link_type: 'Entry',
                        primary_key: id
                    }, _object_spread_props(_object_spread({}, ctx), {
                        path: [
                            ...ctx.path,
                            'items',
                            i
                        ]
                    }))).filter(isNotUndefined)
            }, rest);
        });
    }
    constructor(contentTypeId, schemaFactory){
        _define_property(this, "contentTypeId", void 0);
        _define_property(this, "schemaFactory", void 0);
        this.contentTypeId = contentTypeId;
        this.schemaFactory = schemaFactory;
    }
}

//# sourceMappingURL=Entity.js.map